import { render, staticRenderFns } from "./PatientBalanceReport.vue?vue&type=template&id=71eb7fc5&"
import script from "./PatientBalanceReport.vue?vue&type=script&lang=js&"
export * from "./PatientBalanceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports